import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useCustomerAuth } from '../context/CustomerAuthContext';
import { API_ENDPOINTS } from '../config/api';

export default function AccountPage() {
  const { customer, getAuthHeaders, refreshCustomer, logout } = useCustomerAuth();
  const [form, setForm] = useState({
    firstName: customer?.firstName || '',
    lastName: customer?.lastName || '',
    phone: customer?.phone || '',
  });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  const set = (key) => (e) => {
    setSaved(false);
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      const res = await fetch(API_ENDPOINTS.customerProfile.me, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error('Could not save changes');
      await refreshCustomer();
      setSaved(true);
    } catch (err) {
      setError(err.message || 'Could not save changes');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Header />
      <main className="section">
        <div className="container" style={{ maxWidth: 480 }}>
          <div className="masthead" style={{ marginBottom: '24px' }}>
            <span className="eyebrow">Account</span>
            <h1>Your details</h1>
          </div>

          <div style={{ display: 'flex', gap: '10px', marginBottom: '24px' }}>
            <Link to="/account/orders" className="btn btn-secondary">My orders</Link>
            <Link to="/account/quotes" className="btn btn-secondary">My quotes</Link>
          </div>

          {error && <div style={errorStyle}>{error}</div>}
          {saved && <div style={savedStyle}>Saved.</div>}

          <form onSubmit={handleSubmit}>
            <label style={labelStyle}>First name</label>
            <input type="text" value={form.firstName} onChange={set('firstName')} style={inputStyle} />

            <label style={labelStyle}>Last name</label>
            <input type="text" value={form.lastName} onChange={set('lastName')} style={inputStyle} />

            <label style={labelStyle}>Phone</label>
            <input type="tel" value={form.phone} onChange={set('phone')} style={inputStyle} />

            <label style={labelStyle}>Email</label>
            <input type="email" value={customer?.email || ''} disabled style={{ ...inputStyle, background: '#f5f5f5', color: '#888' }} />

            <button type="submit" disabled={saving} className="btn btn-primary" style={{ marginTop: '4px' }}>
              {saving ? 'Saving…' : 'Save changes'}
            </button>
          </form>

          <button type="button" onClick={logout} style={{ marginTop: '24px', background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: '13px' }}>
            Log out
          </button>
        </div>
      </main>
      <Footer />
    </>
  );
}

const labelStyle = { display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '6px' };
const inputStyle = { width: '100%', padding: '10px', marginBottom: '16px', border: '1px solid #ddd', borderRadius: '6px', fontFamily: 'inherit' };
const errorStyle = { background: '#fef2f2', color: '#ef4444', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '13px' };
const savedStyle = { background: '#f0fdf4', color: '#15803d', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '13px' };
